<div class="flex items-center justify-center dialog-header">
    {{type}} Department
    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>
</div>

<div class="dialog-content" style="margin-top: -15px;">
    <form [formGroup]="departmentForm" (ngSubmit)="onSubmit()" class="p-fluid">
        <div class="field mb-0">
            <label for="name" class="font-medium text-900">Department Name <span class="text-red-500">*</span></label>
            <input id="name" type="text" pInputText formControlName="name"
                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && departmentForm.get('name')?.errors }" />
            <small class="text-red-500" *ngIf="isSubmitted && departmentForm.get('name')?.errors?.['required']">
                Department Name is required
            </small>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-4 gap-4">
            <div class="field mb-0">
                <label for="code" class="font-medium text-900">Department Code <span
                        class="text-red-500">*</span></label>
                <input id="code" type="text" pInputText formControlName="code"
                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && departmentForm.get('code')?.errors }" />
                <small class="text-red-500" *ngIf="isSubmitted && departmentForm.get('code')?.errors?.['required']">
                    Department Code is required
                </small>
            </div>

            <div class="field mb-0">
                <label for="head_of_department" class="font-medium text-900">Head of Department</label>
                <p-select id="head_of_department" [options]="allUsers" formControlName="head_of_department"
                    placeholder="Select Head of Department"></p-select>
            </div>
        </div>

        <div class="field mb-0">
            <label for="description" class="font-medium text-900">Description</label>
            <textarea id="description" rows="3" pTextarea formControlName="description"></textarea>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-4 gap-4">
            <div class="field mb-0">
                <label for="contact_number" class="font-medium text-900">Contact Number</label>
                <input id="contact_number" type="text" pInputText formControlName="contact_number"
                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && departmentForm.get('contact_number')?.errors }" />
                <small class="text-red-500"
                    *ngIf="isSubmitted && departmentForm.get('contact_number')?.errors?.['pattern']">
                    Please enter a valid 10-digit contact number
                </small>
            </div>

            <div class="field mb-0">
                <label for="email" class="font-medium text-900">Email <span class="text-red-500">*</span></label>
                <input id="email" type="email" pInputText formControlName="email"
                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && departmentForm.get('email')?.errors }" />
                <small class="text-red-500" *ngIf="isSubmitted && departmentForm.get('email')?.errors?.['required']">
                    Email is required
                </small>
                <small class="text-red-500" *ngIf="isSubmitted && departmentForm.get('email')?.errors?.['email']">
                    Please enter a valid email address
                </small>
            </div>

        </div>
        <div class="field mb-0">
            <label for="status" class="font-medium text-900">Status <span class="text-red-500">*</span></label>
            <p-dropdown id="status" [options]="statusOptions" formControlName="status" placeholder="Select Status"
                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && departmentForm.get('status')?.errors }">
            </p-dropdown>
            <small class="text-red-500" *ngIf="isSubmitted && departmentForm.get('status')?.errors?.['required']">
                Status is required
            </small>
        </div>

        <div class="field mb-0">
            <div class="flex align-items-center">
                <p-checkbox formControlName="is_public" [binary]="true" inputId="is_public"></p-checkbox>
                <label for="is_public" class="ml-2 font-medium text-900">Public Department</label>
            </div>
        </div>

        <div class="flex justify-end gap-2 mt-4">
            <button pButton type="button" label="Cancel" class="p-button-outlined"
                (click)="handleCloseDialog()"></button>
            <button pButton type="submit" [label]="type" [loading]="btnLoading"></button>
        </div>
    </form>
</div>